module.exports = __webpack_public_path__ + "static/media/5.1.3820b398.png";